module.exports = "/images/04c435dffcae8a45fd45d4caf8e02e8f.svg";